import { useState } from "react";
import { signIn, signUp } from "../lib/auth";
import { Brand } from "./Brand";

/** Sign-in / sign-up gate shown in cloud mode before a session exists. */
export function Login({ onLocal }: { onLocal: () => void }) {
  const [mode, setMode] = useState<"in" | "up">("in");
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ kind: "err" | "ok"; text: string } | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setMsg(null);
    try {
      if (mode === "in") {
        await signIn(email.trim(), pw);
        // onAuthChange in App flips the view — nothing else to do
      } else {
        const { needsConfirm } = await signUp(email.trim(), pw);
        if (needsConfirm) setMsg({ kind: "ok", text: "Check your email to confirm, then sign in." });
      }
    } catch (err) {
      setMsg({ kind: "err", text: err instanceof Error ? err.message : String(err) });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-gate">
      <div className="card pad auth-card">
        <Brand className="auth-brand" />
        <div className="auth-rule" />
        <div className="auth-kicker">Secure property intelligence</div>
        <h1 className="auth-title">{mode === "in" ? "Welcome back." : "Create your workspace."}</h1>
        <div className="note auth-note">
          {mode === "in" ? "Sign in with the email and password for your APAS workspace." : "Create your Beacon by APAS account."}
        </div>
        <form onSubmit={submit}>
          <div className="fld" style={{ marginBottom: 10 }}>
            <label>Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
          </div>
          <div className="fld" style={{ marginBottom: 14 }}>
            <label>Password</label>
            <input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} autoComplete={mode === "in" ? "current-password" : "new-password"} />
          </div>
          <button className="btn btn-p" type="submit" disabled={busy} style={{ width: "100%", justifyContent: "center" }}>
            {busy ? "…" : mode === "in" ? "Sign in" : "Create account"}
          </button>
        </form>
        {msg && (
          <div className={"flag " + (msg.kind === "err" ? "bad" : "ok")} style={{ marginTop: 12 }}>
            <span>{msg.kind === "err" ? "!" : "✓"}</span><div>{msg.text}</div>
          </div>
        )}
        <div style={{ marginTop: 14, textAlign: "center", fontSize: 13 }}>
          {mode === "in" ? (
            <>New here? <a style={{ cursor: "pointer" }} onClick={() => { setMode("up"); setMsg(null); }}>Create an account</a></>
          ) : (
            <>Have an account? <a style={{ cursor: "pointer" }} onClick={() => { setMode("in"); setMsg(null); }}>Sign in</a></>
          )}
        </div>
        <div style={{ marginTop: 12, borderTop: "1px solid var(--line)", paddingTop: 12, textAlign: "center" }}>
          <a style={{ cursor: "pointer", fontSize: 12.5, color: "var(--muted)" }} onClick={onLocal}>Skip — use it on this device for now →</a>
        </div>
      </div>
    </div>
  );
}
